var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{'sr-only': _vm.label.hidden},attrs:{"for":_vm.fieldId}},[_c('span',{domProps:{"textContent":_vm._s(_vm.labelValue)}}),(_vm.validator && _vm.validator.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }